import { render } from "./CustomAmountInput.vue?vue&type=template&id=7fed7e61"
import script from "./CustomAmountInput.vue?vue&type=script&lang=js"
export * from "./CustomAmountInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/martins/www/doarbox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__